import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const arbitrumSepolia: VToken[] = [
  {
    chainId: 421614,
    address: '0x49FB90A5815904649C44B87001a160C1301D6a2C',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[421614][2],
  },
  {
    chainId: 421614,
    address: '0x807dCB6946dDF4C5C6446B1B07ACd248B08F45e2',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[421614][3],
  },
  {
    chainId: 421614,
    address: '0xd9d1e754464eFc7493B177d2c7be04816E089b4C',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[421614][4],
  },
  {
    chainId: 421614,
    address: '0xdEFbf0F9Ab6CdDd0a1FdDC894b358D0c0a39B052',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[421614][5],
  },
  {
    chainId: 421614,
    address: '0x292Ec2b45C549Bc2c6B31937dBd511beaAEabea8',
    decimals: 8,
    symbol: 'vARB_Core',
    underlyingToken: tokens[421614][1],
  },
  {
    chainId: 421614,
    address: '0x4A80b19Cd8BbBd14c425fB17F8E06c6B60801d63',
    decimals: 8,
    symbol: 'vgmWETH-USDC_Core',
    underlyingToken: tokens[421614][10],
  },
  {
    chainId: 421614,
    address: '0x6089B1F477e13459C4d1D1f767c974e5A72a541F',
    decimals: 8,
    symbol: 'vgmBTC-USDC_Core',
    underlyingToken: tokens[421614][9],
  },
  {
    chainId: 421614,
    address: '0x253515E19e8b888a4CA5a0a3363B712402ce4046',
    decimals: 8,
    symbol: 'vwstETH_LiquidStakedETH',
    underlyingToken: tokens[421614][8],
  },
  {
    chainId: 421614,
    address: '0x75f841b14305935D8D7E806f249D9FA52EF1550B',
    decimals: 8,
    symbol: 'vweETH_LiquidStakedETH',
    underlyingToken: tokens[421614][7],
  },
  {
    chainId: 421614,
    address: '0xd7057250b439c0849377bB6C3263eb8f9cf49d98',
    decimals: 8,
    symbol: 'vWETH_LiquidStakedETH',
    underlyingToken: tokens[421614][3],
  },
];
